/* eslint-disable */

import React, { useEffect, useMemo, useReducer, useState } from "react";
import Table from "components/Table";
import api from "api";
import { useAuth } from "context/auth";
import { useLoading, handleLoading } from "context/LoadingContext";
import { useLookups } from "context/lookupsContext";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import Dialog from "components/Dialog/Dialog";
import AddEditEmployeeModal from "./components/AddEditEmployeeModal";
import addNewLog from "utils/addNewLog";
import { generateTextFromJson } from "utils/generateTextFromJson";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function Employees() {
  const [auth] = useAuth();
  const [, loadingDispatch] = useLoading();
  const [dataTable, setDataTable] = useState([]);
  const [userData, setUserData] = useState(null);
  const [userToAction, setUserToAction] = useState({});
  const [addOrEdit, setAddOrEdit] = useState("add");
  const [addEditEmployeeDialogState, addEditEmployeeDispatchDialog] =
    useReducer(dialogReducer, dialogInitState);
  const toggleAddEditEmployeeDialog = (type, data) => {
    setAddOrEdit(type);
    if (data) setUserData(data);
    else setUserData(null);
    addEditEmployeeDispatchDialog({ type: "TOGGLE" });
  };
  //
  const [activateEmployeeDialogState, activateEmployeeDispatchDialog] =
    useReducer(dialogReducer, dialogInitState);
  const toggleActivateEmployeeDialog = (data) => {
    if (data) setUserToAction(data);
    else setUserToAction(null);
    activateEmployeeDispatchDialog({ type: "TOGGLE" });
  };

  const [lookups] = useLookups();
  const { RolesNoPeople } = lookups;

  const headers = useMemo(
    () => [
      {
        accessorKey: "userId",
        header: "#",
        enableColumnFilter: false,
        filterInputInfo: {
          label: "رقم المستخدم",
          type: "",
        },
      },
      {
        accessorKey: "userName",
        header: "اسم المستخدم",
      },
      {
        accessorKey: "roleId",
        header: "نوع المستخدم",
        filterInputInfo: {
          type: "select",
          options: RolesNoPeople || [],
          selectOptions: {
            name: "alias",
            value: "id",
          },
        },
        filterFn: "customEqual",

        cell: (param) =>
          RolesNoPeople?.find(
            (role) => param.cell.row.original.roleId === role.id
          )?.alias || "",
      },
      {
        accessorKey: "actions",
        header: "",
        cellClass: "table__actions",
        // eslint-disable-next-line react/no-unstable-nested-components
        cell: (param) => (
          <div className="table__actions__container">
            <button
              type="button"
              className="employee-requests__card__action badge badge--blue"
              onClick={toggleAddEditEmployeeDialog.bind(
                this,
                "edit",
                param.cell.row.original
              )}
            >
              <i className="fa-solid fa-pen" />
            </button>
            <button
              type="button"
              className={`employee-requests__card__action badge ${
                param.cell.row.original.isActive ? "badge--green" : "badge--red"
              } `}
              onClick={toggleActivateEmployeeDialog.bind(
                this,
                param.cell.row.original
              )}
            >
              {param.cell.row.original.isActive ? (
                <i className="fa-regular fa-square-check" />
              ) : (
                <i className="fa-regular fa-square" />
              )}
            </button>
          </div>
        ),
      },
    ],
    [RolesNoPeople]
  );

  const getUsers = async () => {
    handleLoading(loadingDispatch, true);
    try {
      const usersRes = await api.post("users/admin/", {
        roleIdArray: [2, 1, 4],
      });
      const usersListFromRes = usersRes.data.data.map((item) => {
        const newItem = { roleId: item.roles, ...item.details };
        return newItem;
      });
      setDataTable(usersListFromRes);
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };

  const handleActiveUser = async () => {

    handleLoading(loadingDispatch, true);
    try {
      const { userId, isActive } = userToAction;
      await addNewLog({
        ipAddress: auth.ipAddress,
        hostname: auth.hostname,
        logDescription: `${generateTextFromJson({userId,isActive:`${isActive}`},"تفعيل/تعطيل الحساب ")} `});

      await api.patch("users/admin", {
        isActive: !isActive,
        userId,
      });
      getUsers();
      toggleActivateEmployeeDialog();
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };

  useEffect(() => {
    getUsers();
  }, [auth]);

  return (
    <>
      <div className="users employees">
        <div className="users__header">
          <h2 className="content__title title mt-3">الموظفين</h2>
          <button
            type="button"
            className="btn btn--primary btn--plus mt-3"
            onClick={toggleAddEditEmployeeDialog.bind(this, "add", null)}
          >
            إضافة مستخدم
          </button>
        </div>
        <Table data={dataTable} columns={headers} />
      </div>
      <Dialog
        state={addEditEmployeeDialogState}
        dispatch={addEditEmployeeDispatchDialog}
        footer={false}
        title={addOrEdit === "add" ? "اضافة مستخدم جديد" : "تعديل المستخدم"}
        closeButton
        centered
      >
        <AddEditEmployeeModal
          togglePrintDialog={toggleAddEditEmployeeDialog}
          addOrEdit={addOrEdit}
          getUsers={getUsers}
          userData={userData}
        />
      </Dialog>
      <Dialog
        state={activateEmployeeDialogState}
        dispatch={activateEmployeeDispatchDialog}
        footer={false}
        title="هل انت متأكد من تعطيل/تفعيل المستخدم"
        closeButton
        centered
      >
        <button
          type="button"
          className="btn btn--primary"
          onClick={toggleActivateEmployeeDialog.bind(this, null)}
        >
          لا
        </button>
        <button
          type="button"
          className="btn btn--red"
          style={{ marginInlineStart: "1rem" }}
          onClick={handleActiveUser}
        >
          نعم
        </button>
      </Dialog>
    </>
  );
}

export default Employees;
